import { useAtom } from 'jotai';

import useTranslation from '@/utils/hooks/translation/useTranslation';

// Components
import InputActionTag from '@/components/composite/Form/Input/InputActionTag';
// Atoms
import {
    HashtagsType,
    optionsAtom
} from '@/components/pages/giveaway-picker/Atoms/OptionsAtoms/index';
import { TitleOption } from '@/components/pages/giveaway-picker/OptionsWrapper/components/TitleOption';

export const Hashtags = () => {
    const { t } = useTranslation('giveaway_picker');
    const [options, setOptions] = useAtom(optionsAtom);

    const handleAddItem = (item: HashtagsType) => {
        const itemFormatted = item.startsWith('#') ? item : `#${item}`;
        if (!options.hashtags.includes(itemFormatted)) {
            setOptions((prev) => ({
                ...prev,
                hashtags: [...prev.hashtags, itemFormatted]
            }));
        }
    };

    const handleDeleteItem = (item: HashtagsType) => {
        setOptions((prev) => ({
            ...prev,
            hashtags: prev.hashtags.filter((hashtag) => hashtag !== item)
        }));
    };

    return (
        <div className="flex flex-col gap-3">
            <TitleOption title={t('options.hashtags')} subtitle={t('options.enter_hashtags')} />
            <div>
                <InputActionTag
                    id="hashtags"
                    name="hashtags"
                    placeholder={t('options.hashtags_placeholder')}
                    shouldClearSpace
                    additionalCheckOnEvent={(e) =>
                        e.target.value?.trim() !== '#' && e.target.value.length <= 51
                    }
                    triggerEventList={[' ', 'space']}
                    onAddItem={handleAddItem}
                    onDeleteItem={handleDeleteItem}
                    tagList={options.hashtags || []}
                />
            </div>
        </div>
    );
};
